import { Component, ElementRef, NgZone, OnInit } from '@angular/core';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CustomerSharedService } from '../../customer-shared.service';
import { DeviceService } from '../devices/device.service';
import { CommonService } from '../../../../shared/services/common.service';

import * as XLSX from 'xlsx';

@UntilDestroy({ checkProperties: true })


@Component({
  selector: 'app-assetSensorMapping',
  templateUrl: './assetSensorMapping.component.html',
  styleUrls: ['./assetSensorMapping.component.css']
})
export class AssetSensorMappingComponent implements OnInit {
  isLoading: boolean = false;
  isVisible: boolean = false;

  assetSensorMappingList$: any[] = [];
  filteredAssetSensorMappingList$: any[] = [];
  mappedAssetList$: any[] = [];

  fileList: File[] = [];
  excelErr: string = '';
  excelErrLink: string = '';
  isSuccessMessage: boolean = false;
  excelJsonData: { [key: string]: string | number; }[] | undefined;
  headers: any[] = ['assetId', 'assetName', 'ColdSpotDevEUI', 'HotSpotDevEUI', 'NeitherDevEUI', 'lastUpdateUser'];

  searchText: any;
  searchEnabled = false;
  customer_id: string;
  user_name: string = localStorage.getItem('admin_name') || '';

  constructor(
    public customerSharedService: CustomerSharedService,
    public route: ActivatedRoute,
    public deviceService: DeviceService,
    public commonService: CommonService,
    private ngZone: NgZone,
  ) {
    this.customer_id = this.route.snapshot.paramMap.get('id') || '';
  }


  ngOnInit() {
    this.getAssetSensorMappingbyCustomerId();
    this.getAllAssets();
  }

  getAllAssets() {
    this.deviceService.getAssetByCustomerId(this.customer_id).pipe(untilDestroyed(this)).subscribe(response => {
      if (response?.result && response?.status === 200) {
        this.mappedAssetList$ = response['result'].map((asset: any) => ({
          assetId: asset.asset_id,
          assetName: asset.asset_name,
          ColdSpotDevEUI: '',
          HotSpotDEVEUI: '',
          Neither: '',
          lastUpdateUser: this.user_name
        }));
      }
    })
  }

  downloadTemplate() {
    // Create a merged dataset that contains all assets with mappings
    const mergedData = [...this.mappedAssetList$].map(asset => {
      // Find if this asset has a mapping
      const existingMapping = this.assetSensorMappingList$.find(mapping => mapping.assetId === asset.assetId);

      if (existingMapping) {
        // Use the existing mapping data
        return {
          ...existingMapping,
          mapped: true // Add a flag to identify mapped assets
        };
      } else {
        // Return the unmapped asset
        return {
          ...asset,
          mapped: false
        };
      }
    });

    // Create worksheet headers
    const headers = [...this.headers, 'isReadOnly'];

    // Create worksheet data
    const worksheetData = [
      headers,
      ...mergedData.map(item => {
        const row = [
          item.assetId,
          item.assetName,
          item.ColdSpotDevEUI || '',
          item.HotSpotDevEUI || '',
          item.NeitherDevEUI || '',
          item.lastUpdateUser || this.user_name,
          item.mapped ? 'Yes' : 'No' // Indicate if mapping exists and should be read-only
        ];
        return row;
      })
    ];

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Asset_Sensor_Mapping_File');
    XLSX.writeFile(wb, 'Asset_Sensor_Mapping_File.xlsx');
  }

  getAssetSensorMappingbyCustomerId() {
    this.isLoading = true;
    this.ngZone.runOutsideAngular(() => {
      this.deviceService.getAssetSensorMappingByCustomerId(this.customer_id).pipe(untilDestroyed(this)).subscribe(response => {
        if (response?.result && response?.status === 200) {
          this.assetSensorMappingList$ = response?.result;
          this.filteredAssetSensorMappingList$ = [...this.assetSensorMappingList$]

          this.ngZone.run(() => {
            this.isLoading = false;
          });
        } else {
          this.ngZone.run(() => {
            this.isLoading = false;
          });
        }
      });
    });
  }



  deleteAssetSensorMapping(asm: any) {
    let requestData = {
      idt_asset_sensor: asm.assetId,
    }

    this.deviceService.deleteAssetSensorMapping(requestData).pipe(untilDestroyed(this)).subscribe(response => {
      if (response?.status === 200) {
        this.getAssetSensorMappingbyCustomerId();
      }
    })
  }

  downloadLogFile() {
    this.isVisible = false
    if (this.excelErrLink) {
      window.open(this.excelErrLink, '_blank');
    }
  }

  removeFile() {
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    this.fileList = [...this.fileList, file];
    const fileName = file.name.toLowerCase();
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      if (workbook.SheetNames.length > 0) {
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const excelData: (string | number)[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as (string | number)[][];

        if (excelData.length > 1) {
          const headers = excelData[0]; // First row as headers
          console.log("headers", headers);

          const uniqueColumns = ['ColdSpotDevEUI', 'HotSpotDevEUI', 'NeitherDevEUI'];

          // Collect all values from the unique columns

          const allValues: (string | number)[] = [];
          excelData.slice(1).forEach(row => {
            uniqueColumns.forEach(column => {
              const columnIndex = headers.indexOf(column);
              if (columnIndex !== -1 && row[columnIndex]) {
                allValues.push(row[columnIndex]);
              }
            });
          });

          // Check for duplicates
          const duplicateValues = allValues.filter((value, index) => allValues.indexOf(value) !== index);
          if (duplicateValues.length > 0) {
            console.error('Duplicate values found in unique columns:', duplicateValues);
            // alert(`Duplicate values found in unique columns: ${duplicateValues.join(', ')}`);

            this.commonService.message.error(`Duplicate values found in unique columns: ${duplicateValues.join(', ')}`);
            return; // Stop further processing
          }

          const jsonData = excelData.slice(1).map(row => {
            const obj: { [key: string]: string | number } = {};
            headers.forEach((header, index) => {
              obj[header as string] = row[index] ?? ''; // Handle missing values with a default
            });
            return obj;
          });

          this.excelJsonData = jsonData;
        } else {
          console.error('No data rows found in the worksheet');
        }
      } else {
        console.error('No sheets found in the workbook');
      }

    };
    reader.readAsArrayBuffer(file);
  }


  onExcelSubmit() {
    if (this.excelJsonData) {
      let requestData = {
        fileResponse: this.excelJsonData,
        customerId: this.customer_id
      }
      this.deviceService.addAssetSensorMappingExcel(requestData).pipe(untilDestroyed(this)).subscribe({
        next: (response: any) => {
          this.handleExcelUploadResponse(response);
          this.isLoading = false;
        },
        error: (error: any) => {
          this.handleExcelUploadError(error);
          this.isLoading = false;
        }
      })
    }
  }

  handleExcelUploadResponse(response: any): void {
    if (response?.status === 200) {
      // Check if there's a log file URL in the response
      if (response?.result) {
        this.excelErrLink = response.result;
      }
      // Set success message
      this.isSuccessMessage = true;
      this.excelErr = 'Excel file processed successfully';

      // Only close the modal if there are no errors or warnings
      if (!this.excelErrLink) {
        this.isVisible = false;
        this.fileList = []; // Clear the file list
      }
      this.getAssetSensorMappingbyCustomerId() // Refresh the asset list
    } else {
      // Handle error responses
      this.isSuccessMessage = false;
      this.excelErr = response?.message || response?.error_message || 'Failed to process excel file';
      if (response?.log_file_url) {
        this.excelErrLink = response.log_file_url;
      }
      this.commonService.message.error(this.excelErr);
    }
  }

  handleExcelUploadError(error: any): void {
    this.isSuccessMessage = false;
    this.excelErr = error?.error?.message || 'An error occurred while uploading the excel file';
    if (error?.error?.log_file_url) {
      this.excelErrLink = error.error.log_file_url;
    }
    this.commonService.message.error(this.excelErr);
    console.error('Error uploading excel:', error);
  }

  refreshHandler(): void {
    this.assetSensorMappingList$ = [];
    this.filteredAssetSensorMappingList$ = [];
    this.searchText= "";
    this.getAssetSensorMappingbyCustomerId();
  }

  getSearchDetails(val: any): void {
    let searchText = val.trim().toLowerCase();
    this.filteredAssetSensorMappingList$ = this.assetSensorMappingList$.filter(asm => {
      return (asm.assetName && asm.assetName.toLowerCase().includes(searchText)) ||
        (asm.ColdSpotDevEUI.toString() && asm.ColdSpotDevEUI.toString().includes(searchText)) ||
        (asm.HotSpotDevEUI && asm.HotSpotDevEUI.toLowerCase().includes(searchText)) ||
        (asm.NeitherDevEUI.toString() && asm.NeitherDevEUI.toString().includes(searchText))
    });
  }
}
